<template>
  <div class="table-section">
    <div class="table-top">
      <b-row>
        <b-col md="4" lg="4" class="my-1">
          <p class="table-filter text-left">
            <BaseInput
              type="text" label="Search"
              :inputType="'text'"
              v-model="filter"
              placeholder="Search something..."
              :hasPreIcon="false"
            >
            </BaseInput>
          </p>
        </b-col>
        <b-col md="8" lg="8" class="my-1">
          <p class="table-action text-right">
            <span class="excel-download-btn-hold">
              <button
                type="button"
                class="btn btn-primary btn-semi-rounded mb-2 mr-2"
              >
                <i class="bx bxs-report"></i> &nbsp; &nbsp;
                <download-excel
                  class="excel-download-btn"
                  :data="items"
                  :fields="json_fields"
                  worksheet="My Worksheet"
                  name="filename.xls"
                >
                  Download As Excel
                </download-excel>
              </button>
            </span>
          </p>
        </b-col>
      </b-row>
    </div>
    <b-table
      striped
      hover
      :fields="fields"
      :items="items"
      :busy="isBusy"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      sort-icon-left
      responsive="sm"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filterIncludedFields="filterOn"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <!-- A virtual column -->
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
<!--      {key: "glLevel1Id", label: "GL Level1 Id", sortable: true}, {key:-->
<!--      "glLevel1BankCode", label: "GL Level1 Bank Code", sortable: true}, {key:-->
<!--      "glLevel1BranchCode", label: "GL Level1 Branch Code", sortable: true},-->
<!--      {key: "glLevel1CategoryCode", label: "GL Level1 Category Code", sortable:-->
<!--      true}, {key: "glLevel1Description", label: "GL Level1 Description",-->
<!--      sortable: true}, {key: "glLevel1Status", label: "GL Level1 Status",-->
<!--      sortable: true},-->
      <!-- A virtual composite column -->

      <!-- A custom formatted column -->
      <template v-slot:cell(glLevel1BankCode )="data">
        <p class="name-field">
          <span>{{ data.item.glLevel1BankCode }}</span>
        </p>
      </template>
      <!-- A virtual composite column -->

      <!-- A virtual composite column -->
      <template v-slot:cell(glLevel1CategoryCode)="data">
        <p class="name-field">
          <span>{{ data.item.glLevel1CategoryCode }}</span>
        </p>
      </template>
      <!-- A virtual composite column -->
      <template v-slot:cell(glLevel1Description)="data">
        <p class="name-field">
          <span>{{ data.item.glLevel1Description }}</span>
        </p>
      </template>
      <!-- A virtual composite column -->
      <template v-slot:cell(glLevel1Status)="data">
        <p class="name-field">
          <span
            v-if="data.item.glLevel1Status === 'ACTIVE'"
            class="badge badge-pill badge-soft-success font-size-12"
            >{{ data.item.glLevel1Status }}</span
          >
          <span
            v-if="data.item.glLevel1Status === 'INACTIVE'"
            class="badge badge-pill badge-soft-danger font-size-12"
            >{{ data.item.glLevel1Status }}</span
          >
          <span
            v-if="data.item.glLevel1Status === 'PENDING'"
            class="badge badge-pill badge-soft-warning font-size-12"
            >{{ data.item.glLevel1Status }}</span
          >
        </p>
      </template>
      <!-- Optional default data cell scoped slot -->
      <template v-slot:cell()="data">
        <i>{{ data.value }}</i>
      </template>
    </b-table>
    <b-row>
      <b-col sm="5" md="4" class="my-1">
        <b-form-group
          label="Per page"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            v-model="perPage"
            id="perPageSelect"
            size="sm"
            :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="7" md="8" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import StoreUtils from "../../../../utils/BaseUtils/StoreUtils";
export default {
  name: "AllGlLevel1Table",
  data() {
    return {
      sortBy: "date",
      sortDesc: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      // Note 'isActive' is left out and will not appear in the rendered table
      fields: [
        // A virtual column that doesn't exist in items
        { key: "index", label: "S/N", sortable: true, class: "text-center" },
        // A column that needs custom formatting
        { key: "glLevel1Id", label: "Id", sortable: true },
        { key: "glLevel1BankCode", label: "Bankcode", sortable: true },
        { key: "glLevel1CategoryCode", label: "Categorycode", sortable: true },
        { key: "glLevel1Description", label: "Description", sortable: true },
        { key: "glLevel1Code", label: "Code", sortable: true },
        { key: "glLevel1Status", label: "Status", sortable: true }
      ],
      json_fields: {
        glLevel1BranchCode: "glLevel1BranchCode",
        glLevel1Status: "glLevel1Status",
        glLevel1BankCode: "glLevel1BankCode",
        glLevel1Description: "glLevel1Description",
        glLevel1CreatedDate: "glLevel1CreatedDate",
        glLevel1Id: "glLevel1Id",
        glLevel1CategoryCode: "glLevel1CategoryCode",
        glLevel1UpdatedDate: "glLevel1UpdatedDate",
        glLevel1Code: "glLevel1Code"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ]
    };
  },
  computed: {
    ...mapState({
      items: state => state.glLevel1.glLevel1data,
      isBusy: state => state.glLevel1.moduleLoadingThree
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.filter = " ";
  },
  methods: {
    returnItems() {
      },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  },
  created() {
    const payload = {
      glLevel1BankCode: StoreUtils.rootGetter(StoreUtils.getters.user.GET_USER_BANK_CODE),
      readAll: "NO"
    };
    this.$store.dispatch("glLevel1/allGlLevel1", payload);
  }
};
</script>
<style scoped>
/*.VueTables__date-filter {*/
/*  border: 1px solid #ccc;*/
/*  padding: 6px;*/
/*  border-radius: 4px;*/
/*  cursor: pointer;*/
/*}*/
</style>
